export default "__VITE_ASSET__CC$iIARD__"